import React from "react";
import { Tabs } from "antd";
import PropTypes from "prop-types";
import UserBillingStatements from "./UserBillingStatements";
import BillingNoteList from "../Billing/BillingNoteList";
import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext";

const { TabPane } = Tabs;

// Sub-tabs inside the User Details "BILLING" tab -- statements, credit notes, and debit notes
// each get their own list rather than being stacked on one long page, since each list is
// expected to grow (more statements over time, more notes as Finance issues corrections).
const UserBilling = ({ merchantId }) => {
  const { permissions } = usePermissions();

  return (
    <Tabs defaultActiveKey="statements">
      {permissions?.includes(PERMISSIONS.VIEW_BILLING_STATEMENT_PAGE) && (
        <TabPane tab="Statements" key="statements">
          <UserBillingStatements merchantId={merchantId} />
        </TabPane>
      )}
      {permissions?.includes(PERMISSIONS.VIEW_BILLING_NOTES_PAGE) && (
        <TabPane tab="Credit Notes" key="credit-notes">
          <BillingNoteList
            noteType="CREDIT"
            title="Credit Notes"
            apiBase="/api/credit-notes"
            merchantId={merchantId}
          />
        </TabPane>
      )}
      {permissions?.includes(PERMISSIONS.VIEW_BILLING_NOTES_PAGE) && (
        <TabPane tab="Debit Notes" key="debit-notes">
          <BillingNoteList
            noteType="DEBIT"
            title="Debit Notes"
            apiBase="/api/debit-notes"
            merchantId={merchantId}
          />
        </TabPane>
      )}
    </Tabs>
  );
};

UserBilling.propTypes = {
  merchantId: PropTypes.string.isRequired,
};

export default UserBilling;
